// Fair asssumption of the string being JSON. It needs to start with {
const isPossiblyJson = (message: string) =>
  message.startsWith('{') || message.startsWith('[')

export default isPossiblyJson
